import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { graphql, Subscription } from 'app/shared/graph';
import { GraphDotnetService } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class SubscriptionPermissionService {
    private readonly graphDotnetService = inject(GraphDotnetService);


    getAuthorizedUsers(subscriptionId: string): Observable<Subscription> {
        return this.graphDotnetService.query(graphql`
                query getSubscription($subscriptionId: UUID!) {
                    subscription(id: $subscriptionId) {
                        id
                        label
                        authorizedUsers {
                            user {
                                email
                                picture
                                isMfaEnabled
                            }
                            roles
                        }
                    }
                }
            `, { subscriptionId }
        ).pipe(map(e => e.subscription));
    }
}
